import React, { useState, useEffect, useRef } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import Spinner from "react-bootstrap/Spinner";
import toast from "react-hot-toast";

//API
import ItemService from "../../../../services/supplier_appCommonService";
// SAP integration imports

//Components
import Layout from "../../../../Layout/Layout";
// import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import Modal from "react-bootstrap/Modal";
import { InputField } from "../../../../Components/formElements/InputField";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import { ComboboxField4 } from "../../../../Components/formElements/ComboboxField";
import Constants from "../../../../common/SupplierConstants";
import { getCurrentDate } from "../../../../common/Validations";
import SuccessRegisterModal from "../../../../Components/SuccessRegisterModal";
import HeaderText from "../../../../Components/Modal/supplier_app/PO_Collabration/HeaderText";

const CreateNonPoInvoice = () => {
  localStorage.setItem("menu", "Purchasing");
  localStorage.setItem("submenu", "Non PO Invoice");

  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const modalData = {
    title: "Invoice Creation",
    successMsg: "",
  };
  // Stable callbacks - removed getVendorValue/getCostCenterValue as they are no longer needed
  // (ComboboxField4 uses value/onChange pattern instead of setValue/getvalue)
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getModalInfo, setModalInfo] = useState(modalData);
  const [disabled, setDisabled] = useState(false);

  // File upload states
  const [file, setFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState(false);
  const fileInputRef = useRef(null);
  const abortControllerRef = useRef(null);
  const uploadTokenRef = useRef(0);

  // const [data, setData] = useState([]);
  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);

  // eslint-disable-next-line no-unused-vars
  const [getDisabledStatus, setDisabledStatus] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [getHeaderData, setHeaderData] = useState(false);
  const [itemTableData, setItemTableData] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [removedRows, setRemovedRows] = useState([]);
  const [getCreateInvoiceData, setCreateInvoiceData] = useState([]);
  const [showRestoreModal, setShowRestoreModal] = useState(false);
  const [restoreDraft, setRestoreDraft] = useState([]);
  const [clearSelectedRows, setClearSelectedRows] = useState(false);

  useEffect(() => () => abortControllerRef.current?.abort(), []);

  // ---------------------------------------------------------------------------
  // "Add Items" / "Fill Value" grid — same logic as GRNInvoiceUploadModal
  // ---------------------------------------------------------------------------

  // Human-readable labels/types for the known OCR fields. Any key the OCR
  // sends that is NOT listed here is still shown — with a humanized label — so
  // new/extra fields in header or line items appear automatically.
  const humanize = (key) =>
    String(key)
      .replace(/[_-]+/g, " ")
      .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
      .replace(/\s+/g, " ")
      .trim()
      .replace(/^./, (c) => c.toUpperCase());
  const fieldDefFor = (map, key) =>
    map[key] || { label: humanize(key), type: "text" };

  // Known line-item fields (ordered) with labels/types.
  const LINE_ITEM_LABELS = {
    lineNo: { label: "Line No", type: "text" },
    itemCode: { label: "Item Code", type: "text" },
    description: { label: "Description", type: "text" },
    taxRateType: { label: "Tax Rate Type", type: "text" },
    taxRate: { label: "Tax Rate", type: "number" },
    hsnSac: { label: "HSN/SAC", type: "text" },
    quantity: { label: "Quantity", type: "number" },
    unit: { label: "Unit", type: "text" },
    rate: { label: "Rate", type: "number" },
    discount: { label: "Discount", type: "number" },
    taxableValue: { label: "Taxable Value", type: "number" },
    cgstPercent: { label: "CGST %", type: "number" },
    cgstAmount: { label: "CGST Amt", type: "number" },
    sgstPercent: { label: "SGST %", type: "number" },
    sgstAmount: { label: "SGST Amt", type: "number" },
    igstPercent: { label: "IGST %", type: "number" },
    igstAmount: { label: "IGST Amt", type: "number" },
    productCode: { label: "Product/Service Code", type: "text" },
    cess: { label: "Cess", type: "number" },
    total: { label: "Total", type: "number" },
  };
  const LINE_ITEM_ORDER = Object.keys(LINE_ITEM_LABELS);
  // Helper keys we attach to each row — never shown as data columns.
  const LINE_ITEM_INTERNAL = new Set([
    "local_id",
    "slNo",
    "isManualItem",
    "currencyCode",
  ]);

  // Function to recalculate tax rates for all line items based on header tax code.
  const recalculateAllTaxRates = (headerTaxCodeOverride) => {
    const headerTaxCode = headerTaxCodeOverride ?? formInputs.taxCode;
    if (!headerTaxCode) return;

    const items = itemTableData || [];
    const updatedItems = items.map((item) => {
      const currentTaxRateType = item?.taxRateType || "Standard";

      // Check if the current type is valid for the NEW tax code
      const newRate = taxRateMapByCodeAndType[headerTaxCode]?.[currentTaxRateType];

      if (newRate !== undefined) {
        // VALID: Preserve the user's chosen taxRateType, just update the percentage
        return { ...item, taxRate: newRate, taxCode: headerTaxCode };
      } else {
        // INVALID: Fallback to "Standard" for the new tax code
        const fallbackRate = taxRateMapByCodeAndType[headerTaxCode]?.["Standard"];
        return {
          ...item,
          taxRateType: "Standard",
          taxRate: fallbackRate,
          taxCode: headerTaxCode,
        };
      }
    });

    // Only update state if something actually changed to prevent unnecessary re-renders
    if (JSON.stringify(updatedItems) !== JSON.stringify(items)) {
      setItemTableData(updatedItems);
      setCreateInvoiceData(buildSaveItems(updatedItems));
    }
  };

  // Handle header tax code change - recalculate all line item tax rates
  // Toggleable grid fields = known fields (always offered) + any EXTRA key the
  // OCR put on a line item. buildDefaultActiveFields() then keeps only the ones
  // that actually carry a value, so empty columns stay hidden.
  const extraLineKeys = [];
  (itemTableData || []).forEach((row) =>
    Object.keys(row || {}).forEach((k) => {
      if (
        !LINE_ITEM_INTERNAL.has(k) &&
        !(k in LINE_ITEM_LABELS) &&
        !extraLineKeys.includes(k)
      ) {
        extraLineKeys.push(k);
      }
    }),
  );
  const LINE_ITEM_FIELD_OPTIONS = [...LINE_ITEM_ORDER, ...extraLineKeys].map(
    (k) => ({ key: k, ...fieldDefFor(LINE_ITEM_LABELS, k) }),
  );

  // Known header fields (ordered) shown as editable inputs. Fields already shown
  // by a dedicated input above are excluded (HEADER_EXCLUDE) so they are not
  // duplicated. Extra OCR header keys are appended automatically below.
  const HEADER_LABELS = {
    invoiceType: { label: "Invoice Type", type: "text" },
    referenceNumber: { label: "Reference Number", type: "text" },
    dueDate: { label: "Due Date", type: "text" },
    purchaseOrderNumber: { label: "Purchase Order Number", type: "text" },
    modeOfPayment: { label: "Mode of Payment", type: "text" },
    buyerOrderDate: { label: "Buyer Order Date", type: "text" },
    despatchDocumentNo: { label: "Despatch Document No", type: "text" },
    deliveryNote: { label: "Delivery Note", type: "text" },
    deliveryNoteDate: { label: "Delivery Note Date", type: "text" },
    destination: { label: "Destination", type: "text" },
    supplierGSTIN: { label: "Supplier GSTIN", type: "text" },
    supplierPAN: { label: "Supplier PAN", type: "text" },
    supplierPhone: { label: "Supplier Phone", type: "text" },
    supplierEmail: { label: "Supplier Email", type: "text" },
    supplierAddress: { label: "Supplier Address", type: "textarea" },
    customerName: { label: "Customer Name", type: "text" },
    customerCode: { label: "Customer Code", type: "text" },
    customerGSTIN: { label: "Customer GSTIN", type: "text" },
    customerAddress: { label: "Customer Address", type: "textarea" },
    transporterName: { label: "Transporter Name", type: "text" },
    transporterCode: { label: "Transporter Code", type: "text" },
    vehicleNumber: { label: "Vehicle Number", type: "text" },
    lrNumber: { label: "LR Number", type: "text" },
    ewayBillNumber: { label: "E-Way Bill Number", type: "text" },
    taxableAmount: { label: "Taxable Amount", type: "number" },
    discount: { label: "Discount", type: "number" },
    freight: { label: "Freight", type: "number" },
    packingCharges: { label: "Packing Charges", type: "number" },
    otherCharges: { label: "Other Charges", type: "number" },
    cgst: { label: "CGST", type: "number" },
    sgst: { label: "SGST", type: "number" },
    igst: { label: "IGST", type: "number" },
    cess: { label: "Cess", type: "number" },
    roundOff: { label: "Round Off", type: "number" },
    amountInWords: { label: "Amount in Words", type: "textarea" },
    taxAmountInWords: { label: "Tax Amount in Words", type: "textarea" },
  };
  const HEADER_ORDER = Object.keys(HEADER_LABELS);
  // Header keys already shown by a dedicated input (or that are not scalar) —
  // skipped in the dynamic block so nothing is duplicated.
  const HEADER_EXCLUDE = new Set([
    "invoiceNumber",
    "invoiceDate",
    "supplierName",
    "supplierCode",
    "subtotal",
    "totalTax",
    "grandTotal",
    "totalQuantity",
    "remarks",
    "description",
    "currency",
    "currencyCode",
    "lineItems",
    "hsnSummary",
  ]);

  // Captured raw OCR header (set on upload) — used to surface EXTRA header keys
  // beyond the known set so any new field the OCR returns is also shown.
  const [getOcrHeader, setOcrHeader] = useState({});
  const headerFieldOptions = [
    ...HEADER_ORDER,
    ...Object.keys(getOcrHeader || {}).filter(
      (k) => !HEADER_EXCLUDE.has(k) && !(k in HEADER_LABELS),
    ),
  ].map((k) => ({ key: k, ...fieldDefFor(HEADER_LABELS, k) }));

  // A header field is worth rendering only when it carries a real value.
  const hasHeaderValue = (v) =>
    v !== null && v !== undefined && String(v).trim() !== "";

  const [activeGridFields, setActiveGridFields] = useState([]);
  const [showAddFieldsModal, setShowAddFieldsModal] = useState(false);
  const [fieldDraft, setFieldDraft] = useState([]);
  const [customFieldLabel, setCustomFieldLabel] = useState("");
  const [showFillColumnModal, setShowFillColumnModal] = useState(false);
  const [columnFillDraft, setColumnFillDraft] = useState({});
  const activeFieldsInitializedRef = useRef(false);

  // A line item is worth showing only if it carries actual data.
  const hasLineItemValues = (row) =>
    [
      row?.lineNo,
      row?.itemCode,
      row?.description,
      row?.hsnSac,
      row?.quantity,
      row?.unit,
      row?.rate,
      row?.discount,
      row?.taxableValue,
      row?.cgstPercent,
      row?.cgstAmount,
      row?.sgstPercent,
      row?.sgstAmount,
      row?.igstPercent,
      row?.igstAmount,
      row?.cess,
      row?.total,
    ].some((v) => v !== null && v !== undefined && v !== "");

  // Fields that should always be visible in the line item grid regardless of OCR data
  const ALWAYS_VISIBLE_FIELDS = ["taxRateType", "taxRate"];

  // Only show a data column when at least one line item carries a value for it,
  // or when the field is always visible (e.g., taxRateType, taxRate).
  const shouldShowColumn = (field) =>
    ALWAYS_VISIBLE_FIELDS.includes(field) ||
    (itemTableData || []).some(
      (item) =>
        item[field] !== null && item[field] !== undefined && item[field] !== "",
    );

  // Default visible grid = the default fields that the data actually filled.
  const buildDefaultActiveFields = () =>
    LINE_ITEM_FIELD_OPTIONS.filter((field) => shouldShowColumn(field.key)).map(
      (field) => ({ ...field, isCustom: false }),
    );

  // Master data options for SAP integration dropdowns
  // Each option: { label: "Display Text", value: "internal ID" }
  // "manual" option allows users to type custom values
  // Hardcoded options for now - replace with API calls when ready
  const vendorOptions = [
    { id: 1, name: "Manual entry", label: "Manual entry", value: "manual" },
    { id: 2, name: "V00282", label: "V00282", value: "V00282" },
    { id: 3, name: "V00283", label: "V00283", value: "V00283" },
    { id: 4, name: "V00284", label: "V00284", value: "V00284" },
  ];

  const costCenterOptions = [
    { id: 1, name: "Manual entry", label: "Manual entry", value: "manual" },
    { id: 2, name: "CC1000", label: "CC1000", value: "CC1000" },
    { id: 3, name: "CC1001", label: "CC1001", value: "CC1001" },
    { id: 4, name: "CC1002", label: "CC1002", value: "CC1002" },
  ];

  // Tax dropdown options
  const taxCodeOptions = [
    {
      id: 1,
      name: "84 - Domestic Purchase Intrastate (CGST & SGST)",
      label: "84 - Domestic Purchase Intrastate (CGST & SGST)",
      value: "84",
    },
    {
      id: 2,
      name: "83 - Domestic Purchase Interstate (IGST)",
      label: "83 - Domestic Purchase Interstate (IGST)",
      value: "83",
    },
    {
      id: 3,
      name: "89 - Domestic Purchase Interstate (IGST) - Reverse Charge",
      label: "89 - Domestic Purchase Interstate (IGST) - Reverse Charge",
      value: "89",
    },
    {
      id: 4,
      name: "90 - Domestic Purchase Intrastate (CGST & SGST) - Reverse Charge",
      label: "90 - Domestic Purchase Intrastate (CGST & SGST) - Reverse Charge",
      value: "90",
    },
  ];

  // const taxRateTypeOptions = [
  //   { label: "Standard", value: "Standard" },
  //   { label: "Special 1", value: "Special 1" },
  //   { label: "Special 2", value: "Special 2" },
  //   { label: "Special 3", value: "Special 3" },
  // ];

  const taxRateTypeOptions = [
    { id: 1, name: "Standard", label: "Standard", value: "Standard" },
    { id: 2, name: "Special 1", label: "Special 1", value: "Special 1" },
    { id: 3, name: "Special 2", label: "Special 2", value: "Special 2" },
    { id: 4, name: "Special 3", label: "Special 3", value: "Special 3" },
  ];

  const taxRateMapByCodeAndType = {
    84: { Standard: 9, "Special 1": 2.5, "Special 2": 6, "Special 3": 14 },
    83: { Standard: 18, "Special 1": 5, "Special 2": 12, "Special 3": 28 },
    89: { Standard: 18, "Special 1": 5, "Special 2": 12, "Special 3": 28 },
    90: { Standard: 9, "Special 1": 2.5, "Special 2": 6, "Special 3": 14 },
  };

  // Map tax percentage to tax rate type and rate based on GST categories
  const getTaxRateInfo = (pct) => {
    switch (pct) {
      case 9:
        return { taxRateType: "Standard", taxRate: 9 };
      case 2.5:
        return { taxRateType: "Special 1", taxRate: 2.5 };
      case 6:
        return { taxRateType: "Special 2", taxRate: 6 };
      case 14:
        return { taxRateType: "Special 3", taxRate: 14 };
      case 18:
        return { taxRateType: "Standard", taxRate: 18 };
      case 5:
        return { taxRateType: "Special 1", taxRate: 5 };
      case 12:
        return { taxRateType: "Special 2", taxRate: 12 };
      case 28:
        return { taxRateType: "Special 3", taxRate: 28 };
      default:
        return { taxRateType: "Standard", taxRate: pct };
    }
  };

  // Keep the active fields in sync with the line items: initialise once the
  // first items arrive, and reset when items are cleared so the next upload
  // re-selects its own columns.
  useEffect(() => {
    const items = itemTableData || [];
    if (!items.length) {
      activeFieldsInitializedRef.current = false;
      setActiveGridFields([]);
      return;
    }
    if (activeFieldsInitializedRef.current) return;
    setActiveGridFields(buildDefaultActiveFields());
    activeFieldsInitializedRef.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemTableData]);

  // Build the react-data-table column for one active grid field.
  const fieldColumn = (fieldDef) => ({
    name: fieldDef.label,
    selector: (row) => row?.[fieldDef.key],
    sortable: true,
    width:
      fieldDef.key === "description"
        ? "240px"
        : fieldDef.type === "number"
          ? "130px"
          : "180px",
    cell: (row) => {
      // Special handling for taxRateType to render a filtered dropdown
      if (fieldDef.key === "taxRateType") {
        const headerTaxCode = formInputs.taxCode;

        // Filter options to ONLY show tax rate types that have a valid mapping for the selected tax code
        const availableTaxRateTypes = taxRateTypeOptions.filter(option =>
          headerTaxCode && taxRateMapByCodeAndType[headerTaxCode]?.[option.value] !== undefined,
        );

        return (
          <select
            key={`select-${row?.local_id ?? "x"}-${fieldDef.key}-${row?.[fieldDef.key] ?? ""}`}
            id={`grid-${fieldDef.key}-${row?.local_id ?? "x"}`}
            name={fieldDef.key}
            value={row?.[fieldDef.key] ?? ""}
            onChange={(e) => {
              const value = e.target.value;
              const headerTaxCode = formInputs.taxCode;

              // 1. Prepare all updates for this specific row in one object
              const updates = { [fieldDef.key]: value };

              // 2. If valid, add the derived taxRate to the same update object
              if (headerTaxCode && value) {
                const newTaxRate = taxRateMapByCodeAndType[headerTaxCode]?.[value];
                if (newTaxRate !== undefined) {
                  updates.taxRate = newTaxRate;
                }
              }

              // 3. Apply ALL updates in a single state change to prevent stale overwrites
              setItemTableData((prevItems) => {
                const updatedRows = (prevItems || []).map((item) =>
                  item.local_id === row.local_id ? { ...item, ...updates } : item,
                );
                setCreateInvoiceData(buildSaveItems(updatedRows));
                return updatedRows;
              });
            }}
            required={true}
            disabled={!formInputs.taxCode} // Disable until header tax code is selected
            className="block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 disabled:bg-gray-50 disabled:text-gray-500"
          >
            <option value="" disabled>
              Select Tax Rate Type
            </option>
            {availableTaxRateTypes.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        );
      }

      // Special handling for taxRate to display read-only calculated value with % symbol
      if (fieldDef.key === "taxRate") {
        const rawValue = row?.[fieldDef.key] ?? "";
        const displayValue = rawValue !== "" ? `${rawValue}%` : "";
        return (
          <InputField
            type="text"
            className="inputBox mt-1"
            name={fieldDef.key}
            id={`grid-${fieldDef.key}-${row?.local_id ?? "x"}`}
            value={displayValue}
            disabled={true}
            placeholder="Select tax rate type first"
            required={true}
          />
        );
      }

      // Default handling for other fields
      return (
        <InputField
          type={fieldDef.type}
          className="inputBox mt-1"
          name={fieldDef.key}
          id={`grid-${fieldDef.key}-${row?.local_id ?? "x"}`}
          value={row?.[fieldDef.key] ?? ""}
          onChange={(e) =>
            handleGridCellChange(row, fieldDef.key, e.target.value)
          }
        />
      );
    },
  });

  // Columns are driven entirely by the active (value-bearing) grid fields, so
  // only columns that actually carry data are rendered.
  const mergedColumns = activeGridFields.map(fieldColumn);

  // ---------------------------------------------------------------------------
  // "Add Items" popup — pick default fields and/or create custom fields that
  // will appear as editable columns on the Invoice Items grid.
  // ---------------------------------------------------------------------------
  const openAddFieldsModal = () => {
    setFieldDraft(activeGridFields.map((f) => ({ ...f })));
    setCustomFieldLabel("");
    setShowAddFieldsModal(true);
  };
  const closeAddFieldsModal = () => {
    setShowAddFieldsModal(false);
    setFieldDraft([]);
    setCustomFieldLabel("");
  };
  const applyFields = () => {
    setActiveGridFields(fieldDraft.map((f) => ({ ...f })));
    closeAddFieldsModal();
  };
  const toggleDefaultField = (field) => {
    setFieldDraft((prev) =>
      prev.some((f) => f.key === field.key)
        ? prev.filter((f) => f.key !== field.key)
        : [...prev, { ...field, isCustom: false }],
    );
  };
  // Custom field keys are a unique slug of the label, so re-adding a removed
  // column with the same label keeps the values previously typed on the rows.
  const makeCustomFieldKey = (label, existing) => {
    let slug = label
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "");
    if (!slug) slug = "custom";
    let key = slug;
    let n = 1;
    const taken = new Set(existing.map((f) => f.key));
    while (taken.has(key)) key = `${slug}_${n++}`;
    return key;
  };
  const addCustomField = () => {
    const label = customFieldLabel.trim();
    if (!label) {
      toast.error("Enter a custom field name.", { position: "top-right" });
      return;
    }
    setFieldDraft((prev) => [
      ...prev,
      {
        key: makeCustomFieldKey(label, prev),
        label,
        type: "text",
        isCustom: true,
      },
    ]);
    setCustomFieldLabel("");
  };
  const removeDraftField = (key) => {
    setFieldDraft((prev) => prev.filter((f) => f.key !== key));
  };

  // Add a new blank line item to the Invoice Items grid. The currently ticked
  // fields first become grid columns so the blank row can be filled inline.
  const addNewLineItem = () => {
    // If nothing is ticked (e.g. OCR produced no rows yet), fall back to the
    // core fields so the new row is immediately editable.
    const fieldsToApply =
      fieldDraft.length > 0
        ? fieldDraft
        : LINE_ITEM_FIELD_OPTIONS.map((f) => ({ ...f, isCustom: false }));
    setActiveGridFields(fieldsToApply.map((f) => ({ ...f })));

    const items = itemTableData || [];
    const maxLocalId = [...items, ...(removedRows || [])].reduce(
      (max, it) => Math.max(max, Number(it?.local_id) || 0),
      0,
    );
    const nextSlNo = maxLocalId + 1;
    const newRow = { local_id: nextSlNo, isManualItem: true };
    const updated = [...items, newRow];

    setItemTableData(updated);
    setCreateInvoiceData(buildSaveItems(updated));
    closeAddFieldsModal();
    toast.success(
      `Line item ${nextSlNo} added — enter its values in the grid.`,
      { position: "top-right" },
    );
  };

  // Remove a line item (manually added or data-captured) from the grid.
  // const removeLineItem = (row) => {
  //   const updated = (itemTableData || []).filter(
  //     (item) => item.local_id !== row.local_id,
  //   );
  //   setItemTableData(updated);
  //   setCreateInvoiceData(buildSaveItems(updated));
  // };

  // ---------------------------------------------------------------------------
  // "Fill Value" popup — pick columns that are already shown on the Invoice
  // Items grid and type one value per column; applying it writes that value to
  // every current (visible) line item in that column at once. Only rows already
  // in the grid are touched; rows added later stay empty until filled again.
  // ---------------------------------------------------------------------------
  const openFillColumnModal = () => {
    if (!itemTableData?.length) {
      toast.error("No line items yet — scan/upload an invoice first.", {
        position: "top-right",
      });
      return;
    }
    const draft = {};
    activeGridFields.forEach((f) => (draft[f.key] = ""));
    setColumnFillDraft(draft);
    setShowFillColumnModal(true);
  };
  const closeFillColumnModal = () => {
    setShowFillColumnModal(false);
    setColumnFillDraft({});
  };
  const handleFillFieldChange = (key, value) => {
    setColumnFillDraft((prev) => ({ ...prev, [key]: value }));
  };

  const applyColumnFill = () => {
    const entries = Object.entries(columnFillDraft || {}).filter(
      ([, val]) =>
        val !== undefined && val !== null && String(val).trim() !== "",
    );
    if (!entries.length) {
      toast.error("Enter a value for at least one column.", {
        position: "top-right",
      });
      return;
    }
    const items = itemTableData || [];
    if (!items.length) {
      toast.error("No line items to fill.", { position: "top-right" });
      return;
    }
    const visibleLocalIds = new Set(
      items
        .filter((row) => hasLineItemValues(row) || row?.isManualItem)
        .map((row) => row.local_id),
    );
    if (!visibleLocalIds.size) {
      toast.error("No line items in the grid to fill.", {
        position: "top-right",
      });
      return;
    }
    const values = {};
    entries.forEach(([key, val]) => {
      values[key] = String(val).trim();
    });
    const updated = items.map((item) =>
      visibleLocalIds.has(item.local_id) ? { ...item, ...values } : item,
    );
    setItemTableData(updated);
    setCreateInvoiceData(buildSaveItems(updated));
    closeFillColumnModal();
    toast.success(
      `Filled ${entries.length} column${entries.length > 1 ? "s" : ""} on ${
        visibleLocalIds.size
      } line item${visibleLocalIds.size > 1 ? "s" : ""}.`,
      { position: "top-right" },
    );
  };
  const handleRemoveSelectedRows = () => {
    if (selectedRowKeys.length === 0) {
      toast.error("No rows selected.", { position: "top-right" });
      return;
    }
    const items = itemTableData || [];
    const rowsToRemove = items.filter((row) =>
      selectedRowKeys.includes(String(row.local_id)),
    );
    const remainingRows = items.filter(
      (row) => !selectedRowKeys.includes(String(row.local_id)),
    );
    setItemTableData(remainingRows);
    setCreateInvoiceData(buildSaveItems(remainingRows));
    setRemovedRows((prev) => [...prev, ...rowsToRemove]);
    setSelectedRowKeys([]);
    setClearSelectedRows((prev) => !prev);
    toast.success(`${rowsToRemove.length} item(s) removed`, {
      position: "top-right",
    });
  };
  const openRestoreModal = () => {
    setRestoreDraft([]);
    setShowRestoreModal(true);
  };
  const closeRestoreModal = () => {
    setShowRestoreModal(false);
    setRestoreDraft([]);
  };
  const handleRestoreToggle = (localId) => {
    setRestoreDraft((prev) =>
      prev.includes(localId)
        ? prev.filter((id) => id !== localId)
        : [...prev, localId],
    );
  };
  const applyRestore = (ids) => {
    if (!ids.length) {
      toast.error("Select at least one item to restore.", {
        position: "top-right",
      });
      return;
    }
    const rowsToRestore = (removedRows || []).filter((row) =>
      ids.includes(String(row.local_id)),
    );
    const updated = [...(itemTableData || []), ...rowsToRestore].sort(
      (a, b) => Number(a?.local_id) - Number(b?.local_id),
    );
    setItemTableData(updated);
    setCreateInvoiceData(buildSaveItems(updated));
    setRemovedRows((prev) =>
      prev.filter((row) => !ids.includes(String(row.local_id))),
    );
    setSelectedRowKeys([]);
    setClearSelectedRows((prev) => !prev);
    if (
      (removedRows || []).filter((row) => !ids.includes(String(row.local_id)))
        .length === 0
    ) {
      closeRestoreModal();
    } else {
      setRestoreDraft([]);
    }
    toast.success(`${rowsToRestore.length} item(s) restored`, {
      position: "top-right",
    });
  };
  const restoreSelected = () => applyRestore(restoreDraft);
  const restoreAll = () =>
    applyRestore((removedRows || []).map((r) => String(r.local_id)));

  const [getInvoiceValue, setInvoiceValue] = useState(0);
  const [currentDate] = useState(getCurrentDate("default"));
  const [subTotalValue, setSubTotalValue] = useState(0);
  const [getInvTaxTotalValue, setInvTaxTotalValue] = useState(0);
  const [getOtherChargesValue, setOtherChargesValue] = useState(0);

  const [formInputs, setFormInputs] = useState({
    transactionActivity: "INV",
    subTransactionActivity: "GRN",
    vendorCode: "", // SAP Supplier ID (e.g., "V00282") — not just name
    purchasingDocumentNr: "",
    purchasingDocumentDate: "",
    purchasingDocumentValue: "",
    currency: "INR",
    currencyCode: "INR",
    paymentTerms: "",
    totalInvoiceAmount: "",
    sumOfCurrentAmt: "",
    notes: "",
    weighSlipQty: "",
    itemClass: "",
    vendorInvoiceNo: "",
    vendorInvoiceDate: "",
    vendorInvoiceCurrency: "",
    vendorBasicValue: "",
    vendorFreightValue: "",
    vendorTaxValue: "",
    vendorOtherChargesValue: "",
    vendorTotalInvoiceValue: "",
    invoicedValue: "",
    generatedBy: "",
    createdBy: "",
    // SAP integration fields
    productCode: "", // SAP Service Product ID (e.g., "SRV-MISC-FEE")
    costCenter: "", // SAP Cost Center ID (e.g., "CC1000")
    taxCode: "", // Header-level tax code dropdown
    taxRateType: "", // Header-level tax rate type dropdown
    taxRate: "", // Header-level tax rate (derived from dropdown selections)
    // Manual entry fields
    manualVendorCode: "",
    manualCostCenter: "",
    glAccount: "600002 - Shipping, Freight, and Delivery",
    accountAssignmentType: "Project Task",
    projectTask: "M019-219",
    productType: "Service",
  });

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    // Special handling for manual entry fields
    if (name === "manualVendorCode") {
      setFormInputs((fi) => ({ ...fi, manualVendorCode: value }));
    }
    if (name === "manualCostCenter") {
      setFormInputs((fi) => ({ ...fi, manualCostCenter: value }));
    }
  };

  // Map a (possibly edited) raw OCR line row to the keys the backend expects,
  // WITHOUT dropping any key — every raw OCR field is kept via `...row` and the
  // mapped keys are (re)derived from them so inline edits always flow through to
  // the submit payload.
  const deriveSaveItem = (row) => {
    const qty = Number(row?.quantity) || 0;
    const rate = Number(row?.rate) || 0;
    const total = Number(row?.total) || rate * qty;
    // Map tax percentages to SAP characteristic codes
    let sapTaxCode = "";
    if (Number(row?.igstPercent) > 0)
      sapTaxCode = "83"; // IGST
    else if (Number(row?.cgstPercent) > 0)
      sapTaxCode = "84"; // CGST
    else if (Number(row?.sgstPercent) > 0) sapTaxCode = "85"; // SGST
    const taxPct =
      (Number(row?.cgstPercent) || 0) +
      (Number(row?.sgstPercent) || 0) +
      (Number(row?.igstPercent) || 0);
    const taxAmt =
      (Number(row?.cgstAmount) || 0) +
      (Number(row?.sgstAmount) || 0) +
      (Number(row?.igstAmount) || 0) +
      (Number(row?.cess) || 0);
    const taxRateInfo = getTaxRateInfo(taxPct);
    let taxRateType = taxRateInfo.taxRateType;
    let taxRate = taxRateInfo.taxRate;

    // Override with user-selected tax config if present on the line item.
    // Priority: if the user selected a taxRateType on the line, use it;
    // otherwise fall back to the header tax code when available.
    const headerTaxCode = formInputs?.taxCode;
    const userSelectedTaxRateType = row?.taxRateType;
    const effectiveTaxCode = row?.taxCode || headerTaxCode;

    if (userSelectedTaxRateType && effectiveTaxCode) {
      const codeKey = String(effectiveTaxCode).replace(/^\d+\s*-\s*.*$/, (m) =>
        m.split("-")[0].trim(),
      );
      const rateFromMap =
        taxRateMapByCodeAndType[codeKey]?.[userSelectedTaxRateType];
      if (rateFromMap !== undefined) {
        taxRate = rateFromMap;
        taxRateType = userSelectedTaxRateType;
      } else {
        // No mapping for the chosen type — keep the user's selection but
        // preserve any rate they typed on the line (or the derived one).
        taxRateType = userSelectedTaxRateType;
        taxRate =
          row?.taxRate !== undefined &&
          row?.taxRate !== null &&
          row?.taxRate !== ""
            ? Number(row.taxRate)
            : taxRate;
      }
    } else if (userSelectedTaxRateType) {
      // User picked a type but no tax code is available — keep the type,
      // clear the rate so recalculateAllTaxRates can fill it later.
      taxRateType = userSelectedTaxRateType;
      const fallbackRate =
        taxRateMapByCodeAndType[headerTaxCode]?.[userSelectedTaxRateType];
      if (fallbackRate !== undefined) {
        taxRate = fallbackRate;
      }
    }
    return {
      ...row,
      invoiceQuantity: qty,
      purchaseQuantity: qty,
      orderPriceUnit: rate,
      netValue: total,
      totalPrice: total,
      taxCode: row?.taxCode || sapTaxCode || taxPct || "84",
      taxRateType,
      taxRate,
      invItemTaxValue: taxAmt,
      materialCode: row?.itemCode || row?.description || "",
      materialDescription: row?.description || "",
      orderUnitOfMeasure: row?.unit || "N/A",
      currencyCode: row?.currencyCode || "INR",
      productCode: row?.productCode || "", // carry through SAP product/service code
    };
  };

  // Build the submit payload: keep every row shown in the grid (any captured
  // line, with or without a quantity, plus manually added rows), each mapped
  // through deriveSaveItem (raw keys + mapped keys, nothing removed).
  const buildSaveItems = (items) =>
    (items || [])
      .filter((r) => hasLineItemValues(r) || r?.isManualItem)
      .map(deriveSaveItem);

  // Use functional state update to guarantee latest state on every call
  const handleGridCellChange = (row, key, value) => {
    setItemTableData((prevItems) => {
      const updated = (prevItems || []).map((item) =>
        item.local_id === row.local_id ? { ...item, [key]: value } : item,
      );
      setCreateInvoiceData(buildSaveItems(updated));
      return updated;
    });
  };

  const [HeaderTextModel, setHeaderTextModel] = useState(false);

  /* Header text selected data */
  const [getHeaderTextSelectedData, setHeaderTextSelectedData] = useState([]);
  const handleHeaderTextSelectedData = (data) => {
    setHeaderTextSelectedData(data);
  };

  useEffect(() => {
    // Only recompute Other Charges from header text when rows are actually
    // selected — otherwise it resets auto-filled PO other-charges to 0 on mount.
    if (!getHeaderTextSelectedData?.length) return;
    const getTotal = getHeaderTextSelectedData.reduce(
      (accumulator, currentValue) =>
        accumulator + Number(currentValue?.documentText || 0),
      0,
    );
    setOtherChargesValue(getTotal);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getHeaderTextSelectedData]);

  const hideHeaderTextModel = () => {
    setHeaderTextModel(false);
  };
  // For Upload Success
  // const onSuccessUploadDocumentType = (data) => {
  //   setFormInputs((formInputs) => ({
  //     ...formInputs,
  //     [data.fieldName]: data.attachmentId,
  //   }));
  // };

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  // SAVE
  const handleSave = async () => {
    const headerData = getHeaderData || {};
    formInputs.items = getCreateInvoiceData;
    // Prefer PO header data when it is loaded (PO flow); otherwise keep the
    // values captured from the invoice OCR and fall back to "" — never leave a
    // key undefined, since JSON.stringify would drop it from the payload.
    formInputs.vendorCode =
      headerData.vendorCode ?? formInputs.vendorCode ?? "";
    formInputs.vendorName =
      headerData.vendorName ?? formInputs.vendorName ?? "";
    formInputs.vendorInvoiceDate = currentDate;
    formInputs.deliveredValue =
      headerData.deliveredValue ?? formInputs.deliveredValue ?? "";
    formInputs.deliveredStatus =
      headerData.deliveredStatus ?? formInputs.deliveredStatus ?? "";
    formInputs.invoicedValue =
      headerData.invoicedValue ?? formInputs.invoicedValue ?? "";
    formInputs.invoicedStatus =
      headerData.invoicedStatus ?? formInputs.invoicedStatus ?? "";
    formInputs.paidValue = headerData.paidValue ?? formInputs.paidValue ?? "";
    formInputs.vendorInvoiceCurrency =
      headerData.currencyCode ?? formInputs.currencyCode ?? "";
    formInputs.purchasingDocumentDate =
      headerData.purchasingDocumentDate ??
      formInputs.purchasingDocumentDate ??
      "";
    formInputs.incoTerms = headerData.incoTerms ?? formInputs.incoTerms ?? "";
    formInputs.paymentTerms =
      headerData.paymentTerms ?? formInputs.paymentTerms ?? "";
    formInputs.purchasingDocumentNr =
      headerData.purchasingDocumentNr ?? formInputs.purchasingDocumentNr ?? "";
    formInputs.purchasingDocumentValue =
      headerData.purchasingDocumentValue ??
      formInputs.purchasingDocumentValue ??
      "";
    formInputs.currency = headerData.currency ?? formInputs.currency ?? "";
    formInputs.currencyCode =
      headerData.currencyCode ?? formInputs.currencyCode ?? "";
    formInputs.vendorOtherChargesValue = Number(
      getOtherChargesValue.toFixed(2),
    );
    // Use grandTotal from OCR data directly to avoid double-counting.
    // The OCR's grandTotal already includes subtotal + otherCharges + tax + freight.
    formInputs.vendorTotalInvoiceValue = Number(
      getInvoiceValue ? getInvoiceValue : 0,
    ).toFixed(2);
    formInputs.vendorBasicValue = Number(subTotalValue)?.toFixed(2);
    formInputs.vendorTaxValue = Number(getInvTaxTotalValue);
    formInputs.type = "non-po";

    // console.log(">> handleSave", formInputs);

    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });

    let obj = {
      data: formInputs,
    };

    // console.log(">>obj",obj)

    setDisabled(true);
    await ItemService.addInvoice(obj).then((item) => {
      console.log(">> res!", item);
      if (item?.status === 200) {
        modalData.successMsg = item?.message;
        setModalInfo(modalData);
        onSuccessfullyRegistered();
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    toast.dismiss(toastId);
    setDisabled(false);
  };

  // SAP Integration: Call backend to upload to SAP then save locally
  const handleSapUpload = async () => {
    if (!itemTableData?.length) {
      toast.error(
        "No invoice items to upload. Please upload an OCR invoice first.",
        {
          position: "top-right",
        },
      );
      return;
    }
    setDisabled(true);
    toast.loading("Uploading to SAP...", { position: "top-right" });
    try {
      const result = await ItemService.uploadInvoiceToSapCheckAndMaintain({
        formInputs,
        itemTableData: getCreateInvoiceData,
        headerData: getHeaderData || {},
      });
      toast.dismiss();
      if (result?.status === 200) {
        modalData.successMsg =
          result?.message || "SAP invoice uploaded and saved successfully";
        setModalInfo(modalData);
        onSuccessfullyRegistered();
        toast.success("SAP upload complete! Invoice saved locally.", {
          position: "top-right",
        });
      } else {
        toast.error(result?.message || "SAP upload failed. Please try again.", {
          position: "top-right",
          duration: 5000,
        });
      }
    } catch (err) {
      toast.dismiss();
      toast.error("SAP upload error. Check backend configuration.", {
        position: "top-right",
        duration: 5000,
      });
      console.error("SAP upload error:", err);
    } finally {
      setDisabled(false);
    }
  };

  /* Show Success Modal */
  const onSuccessfullyRegistered = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  // const handleFileChange = (event) => {
  //   // const selectedFile = event.target.files[0];
  //   setFile(event.target.files[0]);
  // };

  // const selectFile = () => {
  //   fileInputRef.current.click();
  // };
  // const cancelInvoice = () => {
  //   setFile(null);
  // };

  const handleFileChange = (event) => {
    setFile(event.target.files?.[0] || null);
  };

  const selectFile = () => {
    fileInputRef.current?.click();
  };

  const cancelInvoice = () => {
    abortControllerRef.current?.abort();
    abortControllerRef.current = null;
    uploadTokenRef.current += 1;
    setUploadStatus(false);
    setFile(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
    setFormInputs((prev) => ({ ...prev, captureInvoiceFile: "" }));
  };

  const uploadInvoice = async () => {
    setUploadStatus(true);
    if (!file) {
      toast.error("Please select a file first.", { position: "top-right" });
      setUploadStatus(false);
      return;
    }
    const controller = new AbortController();
    abortControllerRef.current = controller;
    const myToken = ++uploadTokenRef.current;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("module", "Invoice");
    formData.append("filePath", "invoice");

    try {
      const item = await ItemService.uploadInvoiceOCR(
        formData,
        controller.signal,
      );
      if (myToken !== uploadTokenRef.current) return;

      if (!item?.data) {
        toast.error(
          item?.message || "Invoice OCR upload failed. Please try again.",
          { position: "top-right" },
        );
        setUploadStatus(false);
        return;
      }
      const ocrData = item?.data || {};
      const { lineItems = [], ...ocrHeader } = ocrData;
      setOcrHeader(ocrHeader);

      setFormInputs((prev) => ({
        ...prev,
        ...ocrHeader,
        vendorInvoiceNo: ocrData?.invoiceNumber || prev.vendorInvoiceNo,
        vendorInvoiceDate: ocrData?.invoiceDate || prev.vendorInvoiceDate,
        vendorBasicValue: Number(ocrData?.subtotal) || prev.vendorBasicValue,
        vendorTotalInvoiceValue:
          Number(ocrData?.grandTotal) || prev.vendorTotalInvoiceValue,
        vendorTaxValue:
          Number(ocrData?.cgst ?? 0) +
            Number(ocrData?.sgst ?? 0) +
            Number(ocrData?.igst ?? 0) +
            Number(ocrData?.cess ?? 0) ||
          Number(ocrData?.totalTax) ||
          Number(ocrData?.taxAmount) ||
          prev.vendorTaxValue,
        vendorName: ocrData?.supplierName || prev.vendorName,
        vendorCode: ocrData?.supplierCode || prev.vendorCode,
        currency: ocrData?.currency || "INR",
        currencyCode: ocrData?.currencyCode || "INR",
        invoicedValue: Number(ocrData?.grandTotal) || prev.invoicedValue,
        notes: ocrData?.remarks || ocrData?.description || prev.notes,
        invoiceBillDocument: file ? file.name : prev.invoiceBillDocument,
        weighSlipQty: ocrData?.totalQuantity || "",
      }));

      setSubTotalValue(Number(ocrData?.subtotal) || 0);
      setInvTaxTotalValue(Number(ocrData?.totalTax || ocrData?.taxAmount) || 0);
      setInvoiceValue(Number(ocrData?.grandTotal) || 0);
      setOtherChargesValue(Number(ocrData?.otherCharges) || 0);

      if (lineItems && lineItems.length > 0) {
        setRemovedRows([]);
        setSelectedRowKeys([]);
        const ocrItems = lineItems.map((line, index) => ({
          ...line,
          slNo: index + 1,
          local_id: index + 1,
          currencyCode: ocrData?.currencyCode || "INR",
        }));
        setItemTableData(ocrItems);
        setCreateInvoiceData(buildSaveItems(ocrItems));
      }
      toast.success("Invoice uploaded and populated.", {
        position: "top-right",
      });

      if (file) {
        const fileForm = new FormData();
        fileForm.append("files", file);
        const upItem = await ItemService.uploadFiles(
          fileForm,
          controller.signal,
        );
        if (myToken !== uploadTokenRef.current) return;
        const attachmentId = upItem?.attachmentId || upItem?.data?.attachmentId;
        if (attachmentId) {
          setFormInputs((prev) => ({
            ...prev,
            invoiceBillDocument: attachmentId,
          }));
        }
      }

      setFile(null);
      setUploadStatus(false);
    } catch (err) {
      if (myToken !== uploadTokenRef.current) return;
      if (
        err?.name === "AbortError" ||
        err?.name === "CanceledError" ||
        err?.code === "ERR_CANCELED"
      ) {
        return;
      }
      console.error("Upload error:", err);
      toast.error("Upload failed. Try again.", { position: "top-right" });
      setUploadStatus(false);
    }
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />

      <Row className="justify-center subContent">
        <Col xs={12} md={12} lg={12} className="rightSide quoation">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">
              Create-Non-PO-Invoice
              <span>
                {getHeaderData?.statusHeader === "New" ? (
                  <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                    {getHeaderData?.statusHeader}
                  </span>
                ) : getHeaderData?.statusHeader === "In Release" ? (
                  <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                    {getHeaderData?.statusHeader}
                  </span>
                ) : getHeaderData?.statusHeader === "Acknowledged" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {getHeaderData?.statusHeader}
                  </span>
                ) : (
                  getHeaderData?.statusHeader
                )}
              </span>
            </h2>
            <p className="subText">Fill Invoice Details</p>
            <hr />

            <>
              <Row className="pt-2 pb-4 align-items-center">
                <Col
                  xs={6}
                  md={3}
                  lg={3}
                  className="d-flex justify-content-start mb-2"
                >
                  {!file && (
                    <button onClick={selectFile} className="btnTable">
                      <i className="bi bi-upload mx-1"></i>
                      Upload Invoice
                    </button>
                  )}

                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />

                  {file && (
                    <>
                      {!uploadStatus && (
                        <button className="btnTable" onClick={uploadInvoice}>
                          <i className="bi bi-upload mx-2"></i>
                          Upload
                        </button>
                      )}

                      {uploadStatus && (
                        <button className="btnTable mx-1" disabled={true}>
                          <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                          Loading...
                        </button>
                      )}
                    </>
                  )}
                </Col>

                {file && (
                  <Col xs={6} md={3} lg={3} className="mb-2">
                    <button
                      className="btnDelete"
                      onClick={cancelInvoice}
                      title="Cancel upload"
                    >
                      <i className="bi bi-x-circle"></i>
                    </button>
                  </Col>
                )}
              </Row>
              {/* Invoice header */}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">IH</span>
                      </Col>
                      <Col xs={12} md={9} lg={9}>
                        <span className="headerTitle">Invoice Header</span>
                        <span className="subHeaderTitle">Invoice Header</span>
                      </Col>

                      {/* <Col xs={2} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col> */}
                    </Row>
                  </h2>
                  <div
                    className={`accordion-collapse collapse show ${
                      isCardVisible ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Invoice Date"
                            name="vendorInvoiceDate"
                            placeholder=""
                            value={currentDate}
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Invoice Value"
                            name="invoiceValue"
                            placeholder=""
                            value={getInvoiceValue}
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Qty"
                            name="weighSlipQty"
                            placeholder=""
                            value={formInputs.weighSlipQty}
                            onChange={onInputChange}
                            disabled={false}
                          />
                        </Col>
                        {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Invoice No "
                          name=""
                          placeholder=""
                          // value={""}
                          onChange={onInputChange}
                          disabled={false}
                        />
                      </Col> */}
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding d-flex-column"
                        >
                          <InputField
                            className="inputBox"
                            label="Currency"
                            name="currency"
                            placeholder=""
                            value={formInputs?.currency}
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        {/* <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commLeftRightPadding"
                        >
                          <FileUploadComponent
                            id="invoiceBillDocument"
                            name="invoiceBillDocument"
                            label="Invoice"
                            allowedTypes={[
                              "image/png",
                              "image/jpeg",
                              "application/pdf",
                            ]}
                            multiple={true} // Change to false for single file selection
                            required={true}
                            onSuccessUpload={onSuccessUploadDocumentType}
                            value={formInputs?.invoiceBillDocument || ""}
                            disabled={false}
                          />
                        </Col> */}
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="d-flex flex-column justify-content-center align-items-start commLeftRightPadding"
                        >
                          <span className="d-block fw-medium">
                            Invoice Bill Document
                          </span>
                          {(formInputs.invoiceBillDocument && (
                            <>
                              <img
                                src="assets/img/newIcons/attached-file.png"
                                className="attachmentIcon"
                                alt="attachments"
                                style={{ height: "24px", width: "24px" }}
                                onClick={() =>
                                  handleViewFile(formInputs.invoiceBillDocument)
                                }
                              />
                              <span
                                className="ml-2 text-small text-muted cursor-pointer"
                                style={{
                                  fontSize: "11px",
                                  verticalAlign: "middle",
                                }}
                                onClick={() =>
                                  handleViewFile(formInputs.invoiceBillDocument)
                                }
                              >
                                {String(formInputs.fileName).length > 20
                                  ? String(formInputs.fileName).substring(
                                      0,
                                      20,
                                    ) + "..."
                                  : formInputs.fileName}
                              </span>
                            </>
                          )) ||
                            "--"}
                        </Col>

                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding d-flex-column"
                        >
                          <ComboboxField4
                            id="vendorCodeDropdown"
                            name="vendorCode"
                            label="Vendor Code"
                            placeholder="Select Vendor"
                            data={vendorOptions}
                            value={formInputs.vendorCode}
                            onChange={(value) =>
                              setFormInputs((f) => ({
                                ...f,
                                vendorCode: value,
                              }))
                            }
                            disabled={false}
                          />
                        </Col>
                        {formInputs.vendorCode === "manual" && (
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Vendor Code (Manual)"
                              name="manualVendorCode"
                              placeholder="Enter vendor code"
                              value={formInputs?.manualVendorCode || ""}
                              onChange={onInputChange}
                            />
                          </Col>
                        )}
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding d-flex-column"
                        >
                          <ComboboxField4
                            id="costCenterDropdown"
                            name="costCenter"
                            label="Cost Center"
                            placeholder="Select Cost Center"
                            data={costCenterOptions}
                            value={formInputs?.costCenter}
                            textField="label" // or whatever property your data uses
                            onChange={(value) =>
                              setFormInputs((f) => ({
                                ...f,
                                costCenter: value,
                              }))
                            }
                            disabled={false}
                          />
                        </Col>
                        {formInputs.costCenter === "manual" && (
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Cost Center (Manual)"
                              name="manualCostCenter"
                              placeholder="Enter cost center"
                              value={formInputs?.manualCostCenter || ""}
                              onChange={onInputChange}
                            />
                          </Col>
                        )}
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding d-flex-column"
                        >
                          <InputField
                            className="inputBox"
                            label="Vendor Name"
                            name="vendorName"
                            placeholder=""
                            value={formInputs.vendorName || ""}
                            onChange={onInputChange}
                            disabled={true} // Non-editable for non-po
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Tax Amount"
                            name="taxAmount"
                            placeholder=""
                            value={Number(getInvTaxTotalValue)}
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField4
                            id="taxCodeDropdown"
                            name="taxCode"
                            label="Tax Code"
                            data={taxCodeOptions}
                            value={formInputs.taxCode}
                            onChange={(value) => {
                              setFormInputs((f) => ({ ...f, taxCode: value }));
                              recalculateAllTaxRates(value);
                            }}
                            required={true}
                            disabled={false}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Invoice Number"
                            name="vendorInvoiceNo"
                            id="vendorInvoiceNo"
                            value={formInputs.vendorInvoiceNo}
                            onChange={onInputChange}
                            disabled={false}
                          />
                        </Col>
                        {/*  <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Invoice Date"
                            name="vendorInvoiceDate"
                            id="vendorInvoiceDate"
                            type="date"
                            value={formInputs.vendorInvoiceDate}
                            onChange={onInputChange}
                            disabled={false}
                          />
                        </Col> */}

                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Basic Value"
                            name="vendorBasicValue"
                            placeholder="0.00"
                            id="vendorBasicValue"
                            value={Number(subTotalValue).toFixed(2)}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Tax Amount"
                            name="vendorTaxValue"
                            placeholder="0.00"
                            id="vendorTaxValue"
                            value={Number(getInvTaxTotalValue)}
                            // onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>

                        {/*                               <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Other Charges"
                                  name="vendorOtherChargesValue"
                                  placeholder="0.00"
                                  id="vendorOtherChargesValue"
                                  value={getOtherChargesValue.toFixed(2)}
                                  disabled={true}
                                />
                              </Col> */}
                        {/*   <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Freight Value"
                                  name="vendorFreightValue"
                                  placeholder="0.00"
                                  id="vendorFreightValue"
                                  value={formInputs.vendorFreightValue}
                                  onChange={onInputChange}
                                  disabled={false}
                                />
                              </Col> */}
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Total Invoice Value "
                            name="vendorTotalInvoiceValue "
                            placeholder="0.00"
                            id="vendorTotalInvoiceValue"
                            value={(
                              Number(subTotalValue) +
                              Number(getOtherChargesValue) +
                              Number(getInvTaxTotalValue) +
                              Number(formInputs.vendorFreightValue)
                            ).toFixed(2)}
                            // onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding d-flex-column"
                        >
                          <TextAreaField
                            className="inputBox"
                            label="Notes "
                            name="notes"
                            placeholder=""
                            value={formInputs.notes}
                            onChange={onInputChange}
                            disabled={false}
                          />
                        </Col>
                        {/* Captured header fields from the invoice OCR — only
                            fields that carry a value are shown; any extra key
                            the OCR returns is included automatically. */}
                        {headerFieldOptions
                          .filter((f) => hasHeaderValue(formInputs[f.key]))
                          .map((f) =>
                            f.type === "textarea" ? (
                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                key={f.key}
                                className="commTopButtonRightLeftPadding d-flex-column"
                              >
                                <TextAreaField
                                  className="inputBox"
                                  label={f.label}
                                  name={f.key}
                                  value={formInputs[f.key] ?? ""}
                                  onChange={onInputChange}
                                  disabled={false}
                                />
                              </Col>
                            ) : (
                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                key={f.key}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label={f.label}
                                  type={f.type === "number" ? "number" : "text"}
                                  name={f.key}
                                  value={formInputs[f.key] ?? ""}
                                  onChange={onInputChange}
                                  disabled={false}
                                />
                              </Col>
                            ),
                          )}
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
              {/* invoice service itme details table*/}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible2
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility2}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">ID</span>
                      </Col>
                      <Col xs={8} md={9} lg={9}>
                        <span className="headerTitle">
                          Invoice Service Item Details
                        </span>
                        <span className="subHeaderTitle">
                          Invoice Service Item Details
                        </span>
                      </Col>
                      {/* <Col xs={4} md={2} lg={2} className="">
                        <button className="btnTable">
                          <i className="bi bi-file-excel"></i>Template
                        </button>
                      </Col> */}
                      <Col
                        xs={4}
                        md={2}
                        lg={2}
                        className="d-flex justify-content-end gap-2 flex-no-wrap"
                      >
                        <button
                          className="btnTable"
                          onClick={openAddFieldsModal}
                        >
                          <i className="bi bi-plus-lg mr-1"></i> Add Items
                        </button>
                        <button
                          className="btnTable"
                          onClick={openFillColumnModal}
                          disabled={!itemTableData?.length}
                          title="Set one value for a column on all line items"
                        >
                          <i className="bi bi-chevron-double-down mr-1"></i>{" "}
                          Fill Value
                        </button>
                        {selectedRowKeys.length > 0 && (
                          <button
                            className="btnTable btn-danger"
                            onClick={handleRemoveSelectedRows}
                            title="Remove selected line items"
                          >
                            <i className="bi bi-trash mr-1"></i> Remove (
                            {selectedRowKeys.length})
                          </button>
                        )}
                        {removedRows.length > 0 && (
                          <button
                            className="btnTable"
                            onClick={openRestoreModal}
                            title="Restore removed line items"
                          >
                            <i className="bi bi-arrow-counterclockwise mr-1"></i>{" "}
                            Restore ({removedRows.length})
                          </button>
                        )}
                      </Col>
                      {/* <Col xs={2} md={1} lg={1} className="">
                        <POCollabrationCommonFillter />
                      </Col> */}
                    </Row>
                  </h2>
                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${
                      isCardVisible2 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <DataTable
                            // title=""
                            columns={mergedColumns}
                            data={itemTableData || []}
                            // progressPending={loading}
                            paginationRowsPerPageOptions={
                              Constants.ROW_PER_PAGE
                            }
                            pagination
                            // paginationServer
                            // paginationTotalRows={totalRows}
                            // onChangeRowsPerPage={handlePerRowsChange}
                            // onChangePage={handlePageChange}
                            selectableRows={true}
                            onSelectedRowsChange={({ selectedRows }) =>
                              setSelectedRowKeys(
                                selectedRows.map((r) => String(r.local_id)),
                              )
                            }
                            // selectableRowsToggleAll
                            // selectableRowsHover
                            keyField="local_id"
                            clearSelectedRows={clearSelectedRows}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/* invoice details */}
              {/*     <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible2
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility2}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">ID</span>
                      </Col>

                      <Col xs={4} md={4} lg={4}>
                        <span className="headerTitle"> Invoice details</span>
                        <span className="subHeaderTitle">Invoice details</span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${
                      isCardVisible2 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <div className="accordion-body">
                            <Row className="pt-2 pb-4">
                             



                            </Row>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div> */}

              {/* Upload invoice details */}
              {/*    <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible3
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility3}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">ID</span>
                        </Col>

                        <Col xs={4} md={4} lg={4}>
                          <span className="headerTitle">
                            {" "}
                            Upload Invoice details
                          </span>
                          <span className="subHeaderTitle">
                            Invoice details
                          </span>
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="headerButtonAlign"
                        >
                          <Col
                            xs={6}
                            md={6}
                            lg={6}
                            className="d-flex justify-content-end mr-2 mt-1"
                          >
                            {file && (
                              <p>
                                File: <b>{file.name}</b>{" "}
                              </p>
                            )}
                          </Col>
                          <Col xs={6} md={3} lg={3} className="">
                            {!file && (
                              <button onClick={selectFile} className="btnTable">
                                <i className="bi bi-upload mr-2"></i>
                                Select Invoice
                              </button>
                            )}
                            <input
                              type="file"
                              ref={fileInputRef}
                              style={{ display: "none" }}
                              onChange={handleFileChange}
                            />

                            {file && (
                              <>
                                {!uploadStatus && (
                                  <button
                                    className="btnTable"
                                    onClick={uploadInvoice}
                                  >
                                    <i className="bi bi-upload mr-2"></i>
                                    Upload
                                  </button>
                                )}

                                {uploadStatus && (
                                  <button className="btnTable" disabled={true}>
                                    <Spinner
                                      as="span"
                                      animation="grow"
                                      size="sm"
                                      role="status"
                                      aria-hidden="true"
                                    />
                                    Loading...
                                  </button>
                                )}
                              </>
                            )}
                          </Col>
                          {file && (
                            <Col xs={6} md={1} lg={1} className="">
                              <button
                                className="btnDelete"
                                onClick={cancelInvoice}
                              >
                                <i className="bi bi-x-circle"></i>
                              </button>
                            </Col>
                          )}
                        </Col>
                      </Row>
                    </h2>

                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible3 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <div className="accordion-body">
                              <Row className="pt-2 pb-4">
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Invoice Number *"
                                    name="vendorInvoiceNo"
                                    id="vendorInvoiceNo"
                                    value={invoiceData?.invoiceNumber}
                                    disabled={true}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Invoice Date*"
                                    name="vendorInvoiceDate"
                                    id="vendorInvoiceDate"
                                    value={invoiceData?.invoiceDate}
                                    disabled={true}
                                  />
                                </Col>

                                <Col
                                  xs={12}
                                  md={4}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="totalAmount"
                                    name="vendorBasicValue"
                                    placeholder="0.00"
                                    id="vendorBasicValue"
                                    value={invoiceData?.totalAmount}
                                    disabled={true}
                                  />
                                </Col>
                              </Row>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div> */}

              {/* Invoice Bank Details */}
              {/*   <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible4
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility4}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">ID</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">
                            Invoice Bank Details
                          </span>
                          <span className="subHeaderTitle">
                            Invoice Bank Details
                          </span>
                        </Col>

                        <Col xs={2} md={1} lg={1} className="">
                          <POCollabrationCommonFillter />
                        </Col>
                      </Row>
                    </h2>
                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible4 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField4
                              label="Select Bank A/C Number "
                              placeholder=""
                              data={getSupplierBankData}
                              id="selectedBankDetails"
                              iconClassName="dropdownIcon"
                              name="selectedBankDetails"
                              value={
                                formInputs?.selectedBankDetails?.name || []
                              }
                              onChange={(value) => {
                                setFormInputs((f) => ({
                                  ...f,
                                  selectedBankDetails: {
                                    name: value,
                                    ...f?.selectedBankDetails,
                                  },
                                }));
                              }}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Bank Account Holder Name"
                              name="AccountHolderName"
                              placeholder=""
                              value={getDropdownData?.AccountHolderName}
                              // onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Swift Code/ IFSC Code"
                              name="swiftIfscCode"
                              placeholder=""
                              value={getDropdownData?.swiftIfscCode}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Bank Name"
                              name="bankName2"
                              placeholder=""
                              value={getDropdownData?.bankName2}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding d-flex-column"
                          >
                            <InputField
                              className="inputBox"
                              label="Branch Address"
                              name="bankAddress"
                              placeholder=""
                              value={getDropdownData?.bankAddress}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding d-flex-column"
                          >
                            <InputField
                              className="inputBox"
                              label="Bank Country"
                              name="bankCountry"
                              placeholder=""
                              value={getDropdownData?.bankCountry}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding d-flex-column"
                          >
                            <InputField
                              className="inputBox"
                              label="Bank ID"
                              name="bankKey"
                              placeholder=""
                              value={getDropdownData?.bankKey}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding d-flex-column"
                          >
                            <InputField
                              className="inputBox"
                              label="IBAN"
                              name="iban"
                              placeholder=""
                              value={getDropdownData?.iban}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div> */}

              {/*footer create entry sheet button   */}
              <div className="pageFooter mb-3">
                <Row className="rowDirection">
                  {false && (
                    <Col xs={12} md={2} lg={2} className="">
                      <button
                        className="btn w-full"
                        onClick={handleSave}
                        disabled={disabled}
                      >
                        Post Invoice
                      </button>
                    </Col>
                  )}
                  <Col xs={12} md={2} lg={2} className="">
                    <button
                      className="btn btn-secondary w-full"
                      onClick={handleSapUpload}
                      disabled={disabled || !itemTableData?.length}
                      title="Upload to SAP + Save locally"
                    >
                      Post Invoice
                    </button>
                  </Col>
                </Row>
              </div>
            </>
          </div>
        </Col>
      </Row>

      {/* Header Text */}
      <HeaderText
        index={0}
        headername="Add Other Charges"
        show={HeaderTextModel}
        onHide={hideHeaderTextModel}
        hedertextdata={handleHeaderTextSelectedData}
        showcurrentdata={getHeaderTextSelectedData}
        masterdata="OtherChargesID"
        type="Number"
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />

      <SuccessRegisterModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        modaldata={getModalInfo}
        aftersuccess={Constants.POCOLLABRATION_NON_PO_INVOICE_LIST}
      />

      {/* Add Items popup — choose fields for Invoice Service Item Details grid */}
      <Modal
        show={showAddFieldsModal}
        onHide={closeAddFieldsModal}
        size="md"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton={closeAddFieldsModal}>
          <Modal.Title>Add Items</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="subHeaderTitle mb-3">
            Choose fields to show as columns in Invoice Service Item Details
          </p>
          <div className="mb-3">
            <h6 className="fw-bold">Default fields</h6>
            <Row>
              {LINE_ITEM_FIELD_OPTIONS.map((field) => {
                const isChecked = fieldDraft.some((f) => f.key === field.key);
                return (
                  <Col xs={6} md={6} lg={4} key={field.key} className="mb-1">
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={`draft-${field.key}`}
                        checked={isChecked}
                        onChange={() => toggleDefaultField(field)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`draft-${field.key}`}
                      >
                        {field.label}
                      </label>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
          <div className="mt-3">
            <h6 className="fw-bold">Custom fields</h6>
            <Row className="align-items-end">
              <Col xs={12} md={8}>
                <InputField
                  className="inputBox"
                  label=""
                  name="customFieldLabel"
                  placeholder="e.g. Remarks, Batch No."
                  value={customFieldLabel}
                  onChange={(e) => setCustomFieldLabel(e.target.value)}
                />
              </Col>
              <Col xs={12} md={4} className="mt-2">
                <button
                  className="btnTable"
                  type="button"
                  onClick={addCustomField}
                >
                  <i className="bi bi-plus-lg mr-1"></i> Add
                </button>
              </Col>
            </Row>
            {fieldDraft.filter((f) => f.isCustom).length > 0 && (
              <ul className="list-unstyled mt-2 mb-0">
                {fieldDraft
                  .filter((f) => f.isCustom)
                  .map((f) => (
                    <li
                      key={f.key}
                      className="d-flex justify-content-between align-items-center mb-1"
                    >
                      <span>
                        <i className="bi bi-tag mr-1"></i>
                        {f.label}
                      </span>
                      <button
                        type="button"
                        className="btnDelete"
                        onClick={() => removeDraftField(f.key)}
                        title="Remove field"
                      >
                        <i className="bi bi-x-circle"></i>
                      </button>
                    </li>
                  ))}
              </ul>
            )}
          </div>
          <div className="mt-3 pt-3 border-top">
            <h6 className="fw-bold">Add new item</h6>
            <p className="subHeaderTitle mb-2">
              Add a blank line item to the Invoice Service Item Details grid.
            </p>
            <button className="btnTable" type="button" onClick={addNewLineItem}>
              <i className="bi bi-plus-lg mr-1"></i> Add New Item
            </button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btnTable btn-danger" onClick={closeAddFieldsModal}>
            Cancel
          </button>
          <button className="btnTable" onClick={applyFields}>
            Apply
          </button>
        </Modal.Footer>
      </Modal>

      {/* Fill Value popup */}
      <Modal
        show={showFillColumnModal}
        onHide={closeFillColumnModal}
        size="md"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton={closeFillColumnModal}>
          <Modal.Title>Fill Value for Columns</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "60vh", overflowY: "auto" }}>
          <p className="subHeaderTitle mb-3">
            Enter a value for a column and it will be filled on all current line
            items at once. Leave a field blank to skip that column.
          </p>
          {activeGridFields.length === 0 ? (
            <p className="text-muted mb-0">
              No columns are shown in the Invoice Service Item Details grid yet.
              Use <strong>Add Items</strong> to add columns first.
            </p>
          ) : (
            activeGridFields.map((f) => (
              <div key={f.key} className="mb-2">
                <InputField
                  className="inputBox"
                  label={f.label}
                  type={f.type === "number" ? "number" : "text"}
                  name={`fill-${f.key}`}
                  id={`fill-${f.key}`}
                  placeholder={`Value for ${f.label}`}
                  value={columnFillDraft[f.key] ?? ""}
                  onChange={(e) => handleFillFieldChange(f.key, e.target.value)}
                />
              </div>
            ))
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btnTable btn-danger"
            onClick={closeFillColumnModal}
          >
            Cancel
          </button>
          <button
            className="btnTable"
            onClick={applyColumnFill}
            disabled={activeGridFields.length === 0}
          >
            <i className="bi bi-chevron-double-down mr-1"></i> Apply to all rows
          </button>
        </Modal.Footer>
      </Modal>

      {/* Restore Removed Items popup */}
      <Modal
        show={showRestoreModal}
        onHide={restoreDraft.length > 0 ? undefined : closeRestoreModal}
        size="md"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton={closeRestoreModal}>
          <Modal.Title>Restore Removed Items</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="subHeaderTitle mb-3">
            Select the removed line item(s) you want to restore.
          </p>
          {(removedRows || []).length === 0 ? (
            <p className="text-muted mb-0">No removed items.</p>
          ) : (
            <Row>
              {(removedRows || []).map((row) => (
                <Col xs={12} md={6} lg={4} key={row.local_id} className="mb-2">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={`restore-${row.local_id}`}
                      checked={restoreDraft.includes(String(row.local_id))}
                      onChange={() => handleRestoreToggle(String(row.local_id))}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`restore-${row.local_id}`}
                    >
                      <strong>Line No {row.lineNo || row.slNo || "-"}</strong>
                      {" · "}
                      <span className="text-muted">
                        {row.itemCode || row.description || "-"}
                      </span>
                      {row.quantity !== undefined && (
                        <>
                          {" · "}
                          <span className="text-muted">
                            Qty: {row.quantity}
                          </span>
                        </>
                      )}
                      {row.total !== undefined && (
                        <>
                          {" · "}
                          <span className="text-muted">Total: {row.total}</span>
                        </>
                      )}
                    </label>
                  </div>
                </Col>
              ))}
            </Row>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button className="btnTable btn-danger" onClick={closeRestoreModal}>
            Cancel
          </button>
          <button
            className="btnTable btn-danger"
            onClick={restoreAll}
            disabled={(removedRows || []).length === 0}
          >
            <i className="bi bi-trash mr-1"></i> Restore All
          </button>
          <button
            className="btnTable"
            onClick={restoreSelected}
            disabled={restoreDraft.length === 0}
          >
            <i className="bi bi-check-circle mr-1"></i> Restore Selected
          </button>
        </Modal.Footer>
      </Modal>
    </main>
  );
};

export default CreateNonPoInvoice;
